module.exports = __webpack_public_path__ + "img/rtl2_affiches.8e788e65.jpg";